import PropTypes from "prop-types";
import React, { createRef } from "react";
import Frame from "react-frame-component";
import { BASE_URL, PAYMENTS_URL } from "api_urls";
import getBaseUri from "get_base_uri";

// THIS MUST REMAIN A CLASS COMPONENT TO WORK PROPERLY

// From the docs:
// You may not use the ref attribute on functional components because they don’t have instances:
// You should convert the component to a class if you need a ref to it, just like you do when you need lifecycle methods or state.
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-functional-components
class CreditCardSubmissionFrame extends React.Component {
  constructor(props) {
    super(props);
    this.doSubmit = this.doSubmit.bind(this);
    this.reattemptSubmit = this.reattemptSubmit.bind(this);
    this.formRef = createRef();
    this.recaptchaInputRef = createRef();
    this.submitAttempted = false;
    this.submitSuccess = false;
  }

  doSubmit(token) {
    if (token && this.recaptchaInputRef.current) {
      this.recaptchaInputRef.current.value = token;
    }

    this.submitAttempted = true;
    if (this.formRef.current) {
      this.submitSuccess = true;
      this.formRef.current.submit();
    }
  }

  reattemptSubmit() {
    if (this.submitAttempted && !this.submitSuccess) {
      // retry submit now that frame mount is finished
      this.doSubmit();
    }
  }

  render() {
    const { card, hasRecaptchaInput, merchantKey } = this.props;
    const {
      cardNumber,
      expiryMonth,
      expiryYear,
      cvv,
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      zip,
    } = card;
    const redirectUrl = `${BASE_URL}${getBaseUri()}/payment`;

    return (
      <Frame className="hidden-iframe" contentDidMount={this.reattemptSubmit}>
        <form
          action={PAYMENTS_URL}
          method="POST"
          id="creditform"
          ref={this.formRef}>
          <input
            id="redirect"
            name="redirect_url"
            type="hidden"
            value={redirectUrl}
          />
          <input name="merchant_key" type="hidden" value={merchantKey} />
          {hasRecaptchaInput && (
            <input
              name="recaptcha_token"
              ref={this.recaptchaInputRef}
              type="hidden"
            />
          )}
          <input
            id="credit_card_first_name"
            name="credit_card[first_name]"
            type="text"
            value={firstName}
            readOnly
          />
          <input
            id="credit_card_last_name"
            name="credit_card[last_name]"
            type="text"
            value={lastName}
            readOnly
          />
          <input
            id="credit_card_address_1"
            name="credit_card[address_1]"
            type="text"
            value={address1}
            readOnly
          />
          <input
            id="credit_card_address_2"
            name="credit_card[address_2]"
            type="text"
            value={address2}
            readOnly
          />
          <input
            id="credit_card_city"
            name="credit_card[city]"
            type="text"
            value={city}
            readOnly
          />
          <input
            id="credit_card_state"
            name="credit_card[state]"
            type="text"
            value={state}
            readOnly
          />
          <input
            id="credit_card_zip"
            name="credit_card[zip]"
            type="text"
            value={zip}
            readOnly
          />
          <input
            id="credit_card_number"
            name="credit_card[card_number]"
            type="text"
            value={cardNumber}
            readOnly
          />
          <input
            id="credit_card_month"
            name="credit_card[expiry_month]"
            type="text"
            value={expiryMonth}
            readOnly
          />
          <input
            id="credit_card_year"
            name="credit_card[expiry_year]"
            type="text"
            value={expiryYear}
            readOnly
          />
          <input
            id="credit_card_cvv"
            name="credit_card[cvv]"
            type="text"
            value={cvv}
            readOnly
          />
        </form>
      </Frame>
    );
  }
}

CreditCardSubmissionFrame.propTypes = {
  card: PropTypes.shape({
    cardNumber: PropTypes.string,
    expiryMonth: PropTypes.string,
    expiryYear: PropTypes.string,
    cvv: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  hasRecaptchaInput: PropTypes.bool,
  merchantKey: PropTypes.string.isRequired,
};

CreditCardSubmissionFrame.defaultProps = {
  hasRecaptchaInput: false,
};

export default CreditCardSubmissionFrame;
